
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  flex-grow: 1;
  mix-blend-mode:multiply
}

.tab {
  pointer-events: auto;
  border-bottom-width: 6px;
  border-style: solid;
  border-color: var(--gray-professional-lighten-4);
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 1rem;
  padding-left: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--blue-responsible-darken-2);
  border-right:none !important;
  border-left:none !important;
  border-top:none !important;
  background-image:none !important;
  word-wrap:break-word
}

.tab.tab--active {
  border-color: var(--blue-responsible-darken-2)
}

.tab--active {
  border-radius: 0px !important;
  background-color: var(--blue-responsible-lighten-5) !important;
  font-weight: var(--fw-semibold) !important;
  color: var(--blue-responsible-darken-1) !important
}

.tab:hover:not(.tab--disabled) {
  background-color: var(--blue-responsible-lighten-5) !important;
  color: var(--blue-responsible-darken-1) !important
}

.tab:focus {
  outline: 2px solid transparent;
  outline-offset: 2px
}

.tab:focus:not(.tab--disabled), .tab:focus-visible:not(.tab--disabled) {
  background-color: var(--blue-responsible-lighten-5) !important;
  color: var(--blue-responsible-darken-1) !important
}
`;